export enum PriceAlertType {
    ABOVE = "ABOVE",
    BELOW = "BELOW",
    MOVE = "MOVE"
}
